const viewForPath = (path) => {
  const view = { 0: '0' };
  // eslint-disable-next-line no-unused-vars
  for (const i in path) {
    const key = path.slice(0, i).join('.');
    const value = path[i];
    if (key && value !== undefined) {
      view[key] = value;
    }
  }
  return view;
};

export default viewForPath;
